import { Card, Typography } from '@material-ui/core';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { DateTime } from "luxon";

import styles from './styles';
import debug from 'debug';
import * as types from '../../redux/constants/index';

const output = debug("entry");

function Entry({capsule}) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const displayDate = DateTime.fromISO(capsule.date_target).toLocaleString(DateTime.DATE_FULL)

    const onComponentClicked = () => {
        dispatch({
            type: types.LOAD_CAPSULE,
            payload: capsule
        })

        navigate("/app/editor");
   }

    return (
        <Card sx={styles.cardContainer} onClick={onComponentClicked}>
            <Typography variant='h5' noWrap={true} >{capsule.title}</Typography>
            <Typography variant='subtitle2' noWrap={true} >{displayDate}</Typography>
        </Card>
    )
}

export default Entry